export default __webpack_public_path__ + "static/media/routing.b4a032fb.svg";